import { observer } from 'src/utils/mobx-react';
import React, { ChangeEvent } from 'react';
import { MarketTemplateItem } from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplatesItem';
import { SportMarketTemplatesState } from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplates.state';



type MarketTemplateTagsPropsType = {
    template: MarketTemplateItem | 'loading';
    sportId: string;
    onChange: (value: string, target: string) => void;
    marketTemplatesState: SportMarketTemplatesState;
}
export const MarketTemplateTags = observer('MarketTemplateTags', (props: MarketTemplateTagsPropsType) => {
    const tags = props.marketTemplatesState.getTags;
    const template = props.template;
    if (tags === 'loading' || template === 'loading') {
        return (
            <div className='col-4'>
                <h4>Tags</h4>
                <h3>Loading...</h3>
            </div>
        );
    }
    return (
        <div className='col-4'>
            <h4>Tags</h4>
            <table>
                <thead>
                    <tr>
                        <th>Tag name</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        Object.entries(tags).map((tag) => {
                            const applicable = tag[1]?.applicableTo.includes('market-template');
                            const tagKey = tag[0];
                            const tagDetails = tag[1];
                            if (applicable === false ) {
                                return null;
                            }

                            const selected = Object.entries(template.tags).find(item => item[0] === tagKey);
                            return (
                                <tr key={ tagKey }>
                                    <td>{ tagDetails.label }</td>

                                    <td>
                                        <div className='element'>
                                            <div className='select-wrapper'>
                                                <select onChange={(e: ChangeEvent<HTMLSelectElement>) => props.onChange(e.target.value, tagKey)} defaultValue={selected ? selected[1] : undefined }>
                                                    <option/>
                                                    {
                                                        tagDetails.values.map(item => <option key={tagKey + item.id} value={item.id} >{item.label}</option>)
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>
        </div>
    );
});
